import { Grid } from "@mui/material";
import * as React from "react";
import { Create, required, TextInput } from "react-admin";
import { SimpleForm } from "src/enterprise/ra-rbac";
import { CategoryCreateComponent } from "./CategoryComponent";

export const CategoryCreate = () => {
  return (
    <Create component={CategoryCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={6}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={6}>
            <TextInput
              source="description"
              rows={4}
              fullWidth
              multiline
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
